import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Flex, Text, SegmentedPicker, PatientDistanceField, PatientMovementDetector } from '.';
import { useTestContext } from '../../../../context/testContext';
import { usePostMessage, useReceiveMessage } from '../../../../context/messageContext';
import { useCalibration } from '../../../../context/calibrationContext';

const Separator = styled(Flex)`
  background-color: #aab2b2;
  width: 1px;
  height: 85%;
`;

const ResponsiveAcuityInfoPanel = () => {
  const { testData, updateTestData } = useTestContext();
  const postMessage = usePostMessage();
  const receivedMessage = useReceiveMessage();
  const [patientIsMoving, setPatientIsMoving] = useState(testData.testMode === 'auto' ? true : false);
  const [resizingMode, setResizingMode] = useState(testData.testMode.charAt(0).toUpperCase() + testData.testMode.slice(1));
  const {
    calibrationData: { methodSelected },
  } = useCalibration();

  useEffect(() => {
    const newTestMode = resizingMode.toLowerCase();
    updateTestData({ testMode: newTestMode });
  }, [resizingMode, updateTestData]);

  useEffect(() => {
    if (testData.testMode === 'auto') postMessage({ type: 'recalculateDistance' });
  }, [testData.testMode, postMessage]);

  useEffect(() => {
    if (receivedMessage?.type !== 'patientMovementDetected') return;
    const { patientIsMoving: movementStatusFromMessage } = receivedMessage.content;
    setPatientIsMoving(movementStatusFromMessage);
  }, [receivedMessage]);

  return (
    <Flex height='15vh' width='100%' minWidth='650px' centered marginBottom='1rem' maxHeight='50px'>
      <Flex column padding='0 0.625rem'>
        <Text fontSize='0.875rem' marginBottom='0.5rem'>
          Automatic Resizing Mode
        </Text>
        <SegmentedPicker
          fontSize='0.75rem'
          options={['Auto', 'Off']}
          selectedOption={resizingMode}
          setSelectedOption={setResizingMode}
          disabled={patientIsMoving || methodSelected === 'manual'}
        />
      </Flex>
      <Separator />
      <Flex column padding='0 0.625rem' alignItems='center'>
        <Text fontSize='0.875rem' marginBottom='0.5rem'>
          Patient Distance
        </Text>
        <PatientDistanceField />
      </Flex>
      <Separator />
      <Flex padding='0 0.625rem' column>
        <PatientMovementDetector />
      </Flex>
    </Flex>
  );
};

export default ResponsiveAcuityInfoPanel;
